import React, { useState } from "react";
import { TemplateClassNames } from "../../../../../types/template-layouts";
import { PageModule } from "../../../../../types/working-model";
import BasicInput from "../../../../general-ui/text-input/basic-input";
import { getStylingOverrides } from "../../../utils";

interface IInputSubmitsProps {
	module: PageModule;
	template?: TemplateClassNames;
	placeholder?: string;
	buttonText?: string;
	onChange?: (value: string) => void;
	containerClass?: string;
	onSubmitClick: (value: string) => Promise<{ doNotClear?: boolean }>;
	focus?: boolean;
	setFocus?: React.Dispatch<React.SetStateAction<boolean>>;
}

const InputSubmit: React.FC<IInputSubmitsProps & React.HTMLProps<HTMLInputElement>> = ({
	module,
	placeholder = 'placeholder...',
	buttonText = 'SUBMIT',
	onChange,
	containerClass = '',
	onSubmitClick,
	focus,
	setFocus,
	...rest
}) => {
	const [value, setValue] = useState('');
	const [submitting, setSubmitting] = useState(false);

	const stylingOverrides = getStylingOverrides(module?.styling_overrides);
	const { primaryButtonOverrides } = stylingOverrides;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setValue(e.target.value);
		onChange && onChange(e.target.value);
	};

	const handleClick = async () => {
		setSubmitting(true);
		const { doNotClear } = await onSubmitClick(value);
		setSubmitting(false);
		if (doNotClear) return;
		setValue('');
		onChange && onChange('');
	};

	return (
		<div className={`ask-question-container ${containerClass}`}>
			<div className="ask-question-input-container">
				<BasicInput
					placeholder={placeholder}
					onChange={handleChange}
					value={value}
					disabled={submitting}
					focus={focus}
					setFocus={setFocus}
					onKeyPress={e => {
						if (e.key === 'Enter') {
							handleClick();
						}
					}}
					{...rest}
				/>
			</div>
			<button disabled={submitting} onClick={handleClick} className={`button ${primaryButtonOverrides}`}>{buttonText}</button>
		</div>
	);
};

export default InputSubmit;
